import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import './HomePage.css';

// Placeholder copy for the Solarflare feature; replace with real details as they're announced.
const solarflare = {
    status: "In development",
    tagline: "The next game from the team behind clomp.io.",
    trailerId: "YHUVIlvpwBM",
    description: "We've been building something bigger. Solarflare is our first full-scale game, and we can't wait to show you more. Follow development for news, screenshots, and release updates.",
    highlights: [
        { label: "Status", value: "In development" },
        { label: "Release", value: "TBA" },
        { label: "Platform", value: "TBA" }
    ]
};

const games = [
    { name: "Wordle", path: "/wordle", glyph: "W" },
    { name: "Nonogram", path: "/nonogram", glyph: "▦" },
    { name: "Mania", path: "/mania", glyph: "♪" },
    { name: "Clompy Clicker", path: "/clompyclicker", glyph: "☕" }
];

export class HomePage extends React.Component {

    state = {
        userID: -1,
        isLoggedIn: false,
        requiresLogin: false
    };

    isLoggedIn = () => {
        if (localStorage.getItem('token') === null) {
            return false;
        }
        return true;
    }

    render() {

        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <section className="sf-hero">
                    <div className="sf-sun" aria-hidden="true">
                        <div className="sf-sun-corona"></div>
                        <div className="sf-sun-core"></div>
                    </div>
                    <div className="sf-hero-content">
                        <span className="sf-badge">{solarflare.status}</span>
                        <h1 className="sf-title">Solarflare</h1>
                        <p className="sf-tagline">{solarflare.tagline}</p>
                        <div className="home-actions">
                            <a href="#trailer" className="home-btn sf-btn-primary">
                                <svg className="sf-play-icon" viewBox="0 0 10 12" aria-hidden="true"><path d="M0 0 L10 6 L0 12 Z" fill="currentColor" /></svg>
                                Watch the trailer
                            </a>
                            <Link to="/news" className="home-btn sf-btn-ghost">Follow development</Link>
                        </div>
                    </div>
                </section>

                <main className="home">
                    <section className="sf-trailer" id="trailer">
                        <p className="home-eyebrow sf-eyebrow">Watch the trailer</p>
                        <div className="sf-trailer-frame">
                            <iframe
                                className="sf-trailer-video"
                                src={"https://www.youtube-nocookie.com/embed/" + solarflare.trailerId}
                                title="Solarflare trailer"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </section>

                    <section className="sf-about">
                        <div className="sf-about-text">
                            <p className="home-eyebrow sf-eyebrow">About the game</p>
                            <h2>Something bigger is on the horizon</h2>
                            <p>{solarflare.description}</p>
                        </div>
                        <dl className="sf-facts">
                            {solarflare.highlights.map((fact) => (
                                <div className="sf-fact" key={fact.label}>
                                    <dt>{fact.label}</dt>
                                    <dd>{fact.value}</dd>
                                </div>
                            ))}
                        </dl>
                    </section>

                    <section className="home-section">
                        <div className="home-section-header">
                            <div>
                                <h2>While you wait</h2>
                                <p className="home-subtitle">Our quick web games are still here.</p>
                            </div>
                            <Link to="/games" className="home-link">All games →</Link>
                        </div>
                        <div className="home-games">
                            {games.map((game) => (
                                <Link to={game.path} className="home-game" key={game.path}>
                                    <span className="home-game-glyph" aria-hidden="true">{game.glyph}</span>
                                    <span className="home-game-name">{game.name}</span>
                                </Link>
                            ))}
                        </div>
                    </section>
                </main>
            </>
        );

    }

}
